import React, { Component } from "react";
import Select from "react-select";
import { helperFunctions as HF } from "../../helper/helperFunctions";
import { customSelectStyles } from "../ThemeComponents/selectStyles";

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contact: {
                first_name: "",
                last_name: "",
                email: "",
                phone: "",
                type_id: "",
                customer_id:
                    this.props.contactObject.contact ? this.props.contactObject.contact.customer_id || '' : ''

            },
            states: [],
            submitted: false
        };
        this.onChange = this.onChange.bind(this);
        this.contactTypeChangeHandler = this.contactTypeChangeHandler.bind(
            this
        );
    }

    componentDidMount() {
        this.setState(prevState => ({
            ...prevState,
            contact: {
                ...prevState.contact,
                ...this.props.contactProp.contact
            }
        }));
    }

    onChange(e) {
        this.setState({
            contact: {
                ...this.state.contact,
                [e.target.name]: e.target.value
            }
        });
    }

    contactTypeChangeHandler(e) {
        this.setState({
            contact: {
                ...this.state.contact,
                type: e.label,
                type_id: e.value
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.contact !== prevState.contact) {
            this.props.returnState({
                contact: this.state.contact
            });
        }
    }

    openAddNewTagForm = (modelType, displayTitle, listTypeId) => {
        this.props.returnState({
            tagTypeAddModal: true,
            addNewModelType: modelType,
            addNewModelDisplayTitle: displayTitle,
            list_type_id: listTypeId
        });
    };

    getOptions() {
        if (this.props.contactTypesProp === undefined) {
            return [];
        }
        let returnObj = (id, title, disable) => {
            return {
                value: id,
                label: title,
                isDisabled: disable
            }
        }
        return this.props.contactTypesProp.map(({ id, title }) => {
            if (this.state.contact && this.state.contact.type === 'primary') {
                return returnObj(id, title, true);
            } else {
                if (title === 'primary') {
                    return returnObj(id, title, true);
                }
                return returnObj(id, title, false);
            }

        });
    }

    render() {
        if (!this.state.contact) {
            return <div></div>;
        }
        const { first_name, last_name, email, phone, type_id, type } = this.state.contact;
        return (
            <React.Fragment>
                <div className="mt-md fieldWithIcon">
                    <span className="fieldIcon userIcon"></span>
                    <input
                        type="text"
                        name="first_name"
                        className="form-control"
                        placeholder="First Name"
                        value={first_name}
                        onChange={this.onChange}
                    />
                    {/* {this.validatorCustomer.message('first_name', first_name, 'required')} */}
                    {this.props.requiredField.first_name && (
                        <span className="customMsg">
                            {this.props.validatorInstance.message(
                                "First Name",
                                first_name,
                                this.props.requiredField.first_name
                            )}
                        </span>
                    )}
                </div>
                <div className="mt-md fieldWithIcon">
                    <span className="fieldIcon userIcon"></span>
                    <input
                        type="last_name"
                        name="last_name"
                        className="form-control"
                        placeholder="Last Name"
                        value={last_name}
                        onChange={this.onChange}
                    />

                </div>
                {
                    (window.location.href.includes('contacts') || window.location.href.includes('customer') || window.location.href.includes('brand') || window.location.href.includes('profile')) &&
                    <div className="mt-md fieldWithIcon">
                        <span className="fieldIcon emailIcon"></span>
                        <input
                            type="email"
                            name="email"
                            autoComplete="off"
                            className="form-control"
                            placeholder="Contact Email"
                            value={email}
                            onChange={this.onChange}
                        />
                        {this.props.requiredField.email && (
                            <span className="customMsg">
                                {this.props.validatorInstance.message(
                                    "Email",
                                    email,
                                    this.props.requiredField.email
                                )}
                            </span>
                        )}
                    </div>
                }

                {
                    (window.location.href.includes('contacts') || window.location.href.includes('customer') || window.location.href.includes('brand') || window.location.href.includes('profile')) &&
                    <div className="mt-md fieldWithIcon">
                        <span className="fieldIcon userIcon"></span>
                        <input
                            type="text"
                            name="phone"
                            autoComplete="off"
                            className="form-control"
                            placeholder="Phone Number"
                            value={phone}
                            onChange={this.onChange}
                        />
                    </div>
                }


                {this.props.contactTypesProp && (
                    <div className="mt-md fieldWithIcon">
                        <Select
                            styles={customSelectStyles}
                            value={HF.returnLabelWithValue(
                                type_id,
                                this.getOptions()
                            )}
                            onChange={this.contactTypeChangeHandler}
                            options={this.getOptions()}
                            isSearchable={true}
                            name={"type_id"}
                            isMulti={false}
                            placeholder={"Contact Type"}
                            isClearable={false}
                        />
                        {this.props.validatorInstance.message(
                            "Contact Type",
                            type_id,
                            "required"
                        )}
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/Contact.jsx